import { Component } from '@angular/core';

@Component({
    selector: 'registration/teammemberthankyou',
    template: require('./team.member.thank.you.component.html')
})
export class TeamMemberThankYouComponent { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/registration/team.member.thank.you.component.ts